module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_74-f19738711a9416e13ea509a024c70eea.png";